// Mixed Variety Pack - AJAX Add to Cart
document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('.product-form');
  const addToCartBtn = document.getElementById('AddToCart-mixed-variety');
  const addToCartText = document.getElementById('AddToCartText-mixed-variety');
  
  if (!form || !addToCartBtn) return;
  
  // Check if this is the mixed variety pack page
  const isMixedVariety = form.closest('#shopify-section-mixed-variety');
  if (!isMixedVariety) return;
  
  // AJAX Add to Cart function
  async function addToCartAjax(variantId, quantity, sellingPlanId = null) {
    const formData = {
      id: variantId,
      quantity: quantity || 1
    };
    
    if (sellingPlanId) {
      formData.selling_plan = sellingPlanId;
    }
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Cart API error:', errorText);
        throw new Error(`Failed to add to cart: ${response.status} ${response.statusText}`);
      }
      
      const data = await response.json();
      console.log('Item added to cart:', data);
      
      // Update cart count badge
      await updateCartCount();
      
      // Navigate to cart page
      navigateToCart();
      
      return data;
    } catch (error) {
      console.error('Error adding to cart:', error);
      throw error;
    }
  }

  // Update cart count badge
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const cartLink = document.querySelector('.site-header__cart');
      
      if (!cartLink) {
        console.warn('Cart link not found');
        return;
      }
      
      let cartCountEl = document.getElementById('CartCount');
      
      if (cart.item_count > 0) {
        // Create badge if it doesn't exist
        if (!cartCountEl) {
          cartCountEl = document.createElement('div');
          cartCountEl.id = 'CartCount';
          cartCountEl.className = 'site-header__cart-count';
          cartLink.appendChild(cartCountEl);
        }
        
        // Update count
        let countSpan = cartCountEl.querySelector('span');
        if (!countSpan) {
          countSpan = document.createElement('span');
          cartCountEl.appendChild(countSpan);
        }
        countSpan.textContent = cart.item_count;
        
        // Ensure badge is visible
        cartCountEl.style.display = 'flex';
      } else {
        // Hide badge if cart is empty
        if (cartCountEl) {
          cartCountEl.style.display = 'none';
        }
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  // Navigate to cart page
  function navigateToCart() {
    setTimeout(() => {
      window.location.href = '/cart';
    }, 100);
  }

  // Update product image based on selected variant
  function updateProductImage(variant, sectionId) {
    // Find image container and image element using section ID
    const imageContainer = document.querySelector(`#mvp-image-container-${sectionId}`);
    const imageEl = document.querySelector(`#mvp-featured-image-${sectionId}`);
    
    if (!imageContainer || !imageEl) return;
    
    // Get the variant's featured image, or fallback to product featured image
    let imageUrl = null;
    let imageAlt = '';
    
    // Get product data from ProductJson
    const productJsonEl = document.querySelector(`#ProductJson-${sectionId}`);
    if (productJsonEl) {
      try {
        const productData = JSON.parse(productJsonEl.textContent);
        
        // Check if variant has a featured_image (Shopify stores as URL string)
        if (variant && variant.featured_image) {
          imageUrl = variant.featured_image;
          imageAlt = productData.title || '';
        } else if (productData.featured_image) {
          // Use product featured image
          imageUrl = productData.featured_image;
          imageAlt = productData.title || '';
        } else if (productData.images && productData.images.length > 0) {
          // Use first product image
          imageUrl = productData.images[0];
          imageAlt = productData.title || '';
        }
      } catch (e) {
        console.error('Error parsing product JSON:', e);
      }
    }
    
    if (imageUrl) {
      // Handle Shopify image URL format
      // imageUrl can be a string URL or an object with src property
      let imageSrc = typeof imageUrl === 'string' ? imageUrl : (imageUrl.src || imageUrl);
      
      // Remove query parameters and size suffixes
      const cleanUrl = imageSrc.split('?')[0].replace(/_(?:small|medium|large|grande|master|\d+x\d+)\./, '.');
      const extension = cleanUrl.match(/\.(jpg|jpeg|png|gif|webp)$/i);
      const ext = extension ? extension[1] : 'jpg';
      const urlWithoutExt = cleanUrl.replace(/\.(jpg|jpeg|png|gif|webp)$/i, '');
      
      // Build responsive srcset using Shopify's img_url format
      // We'll use the Shopify CDN URL format
      const baseUrl = urlWithoutExt;
      const sizes = '(min-width: 768px) 350px, 100vw';
      const srcset = [
        `${baseUrl}_400x.${ext} 400w`,
        `${baseUrl}_600x.${ext} 600w`,
        `${baseUrl}_800x.${ext} 800w`,
        `${baseUrl}_1000x.${ext} 1000w`
      ].join(', ');
      
      // Update image
      imageEl.src = `${baseUrl}_600x.${ext}`;
      imageEl.srcset = srcset;
      imageEl.sizes = sizes;
      imageEl.alt = imageAlt;
      imageEl.style.display = 'block';
      imageEl.style.visibility = 'visible';
      imageEl.style.opacity = '1';
      
      // Remove lazy loading classes if present
      imageEl.classList.remove('lazyload', 'lazypreload');
      imageEl.classList.add('lazyloaded');
    }
  }
  
  // Find the product section and listen for variant changes
  const productSection = form.closest('[id^="ProductSection-"]');
  if (productSection) {
    const sectionId = productSection.id.replace('ProductSection-', '');
    
    // Listen for variant change events from theme.js (using jQuery if available)
    if (typeof $ !== 'undefined') {
      $(productSection).on('variantChange', function(evt) {
        if (evt.variant) {
          updateProductImage(evt.variant, sectionId);
        }
      });
      
      $(productSection).on('variantImageChange', function(evt) {
        if (evt.variant) {
          updateProductImage(evt.variant, sectionId);
        }
      });
    }
    
    // Also listen for direct select changes as fallback
    const variantSelects = form.querySelectorAll('.single-option-selector');
    variantSelects.forEach(select => {
      select.addEventListener('change', function() {
        // Get current variant from the hidden select
        const hiddenSelect = form.querySelector('select[name="id"]');
        if (hiddenSelect && hiddenSelect.value) {
          const productJsonEl = document.querySelector(`#ProductJson-${sectionId}`);
          if (productJsonEl) {
            try {
              const productData = JSON.parse(productJsonEl.textContent);
              const variant = productData.variants.find(v => v.id.toString() === hiddenSelect.value);
              if (variant) {
                updateProductImage(variant, sectionId);
              }
            } catch (e) {
              console.error('Error parsing product JSON:', e);
            }
          }
        }
      });
    });
  }
  
  // Handle form submission
  form.addEventListener('submit', async function(e) {
    e.preventDefault();
    
    // Get variant ID from the hidden select (updated by variant selector)
    const variantSelect = form.querySelector('select[name="id"]');
    const quantityInput = form.querySelector('input[name="quantity"]');
    
    if (!variantSelect) {
      console.error('Variant select not found');
      form.submit(); // Fallback to normal submission
      return;
    }
    
    const variantId = variantSelect.value;
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    
    if (!variantId) {
      console.error('Variant ID is empty');
      form.submit(); // Fallback to normal submission
      return;
    }
    
    // Check for selling plan (subscription)
    const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : null;
    
    // Disable button during request
    const originalText = addToCartText ? addToCartText.textContent : addToCartBtn.textContent;
    addToCartBtn.disabled = true;
    if (addToCartText) {
      addToCartText.textContent = 'Adding...';
    } else {
      addToCartBtn.textContent = 'Adding...';
    }
    
    try {
      await addToCartAjax(variantId, quantity, sellingPlanId);
      // Success - navigation will happen in addToCartAjax
    } catch (error) {
      // Fallback to form submission
      console.error('AJAX add to cart failed, falling back to form submission:', error);
      if (addToCartText) {
        addToCartText.textContent = originalText;
      } else {
        addToCartBtn.textContent = originalText;
      }
      addToCartBtn.disabled = false;
      form.submit();
    }
  });
});

